import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalComponentBaseProps } from '@pcmp/react-providers';

import Button from '@ingka/button';
import { Prompt, ModalHeader, ModalFooter } from '@ingka/modal';
import InlineMessage from '@ingka/inline-message';
import InformationIcon from '@ingka/ssr-icon/paths/information-circle';

type PromptModalProps = ModalComponentBaseProps & {
  confirm: () => void;
};

const IconPreviewModal: FC<PromptModalProps> = ({
  handleDismiss,
  confirm,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <Prompt
      {...rest}
      data-testid="prompt-icon-preview"
      title={t('page.showIcon.title')}
      footer={
        <ModalFooter>
          <Button
            data-testid="prompt-cancel"
            text={t('label.done')}
            type="secondary"
            onClick={handleDismiss}
          />
        </ModalFooter>
      }
      header={<ModalHeader ariaCloseTxt={t('label.goBack')} />}
      titleId="icon-preview-prompt"
    >
      <p>{t('page.showIcon.text1')}</p>
      <div className="my-4 flex justify-center">
        <img
          src="/assets/qr-icon.svg"
          alt={t('page.showIcon.image')}
          width={100}
          height={100}
        />
      </div>
      <p>{t('page.showIcon.text2')}</p>
      <InlineMessage
        body={t('page.showIcon.text3')}
        link=""
        linkLabel=""
        ssrIcon={InformationIcon}
        title=""
        variant="informative"
        className="mt-4"
      />
    </Prompt>
  );
};

export default IconPreviewModal;
